import styles from './slug-field.module.scss';

interface SlugFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  disabled: boolean;
  /** Shown under the input and marks it invalid. */
  error?: string;
  /** Prefix for the input's and the error's test ids (`${testId}-input`, `${testId}-error`). */
  testId: string;
}

export const SlugField = ({ value, onChange, placeholder, disabled, error, testId }: SlugFieldProps) => (
  <div className={styles.field}>
    <input
      className={styles.slugInput}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      disabled={disabled}
      aria-invalid={!!error}
      data-testid={`${testId}-input`}
    />
    {error && (
      <p className={styles.fieldError} data-testid={`${testId}-error`}>
        {error}
      </p>
    )}
  </div>
);
